import { SET_GLOBAL_ACCOUNT_V2_SUMMARY } from './globalAccountV2SummaryActionTypes';

export const setGlobalAccountV2Summary = (payload) => {
  return {
    type: SET_GLOBAL_ACCOUNT_V2_SUMMARY,
    payload,
  };
};
